import React, { useEffect } from 'react';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import { Box, Grid, TextField, Autocomplete } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { createState, useState, Downgraded } from '@hookstate/core';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import moment from 'moment';
import { ScheduleUserType } from '../../constants/Constant';
import TimeSelector from '../../sharedcomponents/timeSelector/timeSelector';
import MUIDatePicker from '../../sharedcomponents/datePicker';
import dayjs from 'dayjs';

const activitySate = createState({
    eventName: '',
    startDate: null,
    endDate: null,
    startDateTime: null,
    endDateTime: null,
    location: '',
    attire: '',
    notes: '',
    activityTags: []
});

const AddAcctivity = (props) => {
    const state = useState(activitySate);
    const userInfo = useState(null);
    const eventData = useState(null);
    const tags = useState([]);
    const activityTags = useState([]);

    const [nameError, setNameErr] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const activityInfo = useState(null);
    const [disableBtn, setDisableBtn] = React.useState(true);

    useEffect(() => {
        const guserInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');
        userInfo.set(guserInfo);
        if (
            eventData.get() == null ||
            (eventData.get() && eventData.eventID.value != eventInfo.eventID)
        ) {
            eventData.set(eventInfo);
        }
        ApiHelper.get(APIURLConstants.GET_TAGS(eventInfo.eventID)).then(
            (res) => {
                let tData = res.data.filter((item) => item.status == 1);
                tags.set(tData);

                if (props.activityInfo !== null && tData != null) {
                    let selectedTags = props.activityInfo.activityTags !== null
                        ? tData.filter((x) =>
                            props.activityInfo.activityTags
                                .map((y) => y.tagID)
                                .includes(x.tagID)
                        )
                        : [];

                    state.activityTags.set(selectedTags);
                    if (
                        props.activityInfo !== null &&
                        props.activityInfo.activityTags !== null
                    )
                        activityTags.set(selectedTags);
                }
            }
        );
    }, []);

    useEffect(() => {
        activityInfo.set(props);
        if (props.activityInfo != null) {
            let info = props.activityInfo;
            let selectedTags = info.activityTags !== null
                ? tags
                    .attach(Downgraded)
                    .get()
                    .filter((x) =>
                        info.activityTags
                            .map((y) => y.tagID)
                            .includes(x.tagID)
                    )
                : [];
            state.set({
                eventName: info.activityName,
                startDate:
                    info.startDateTime !== null
                        ? moment(info.startDateTime)
                        : null,
                startDateTime:
                    info.startDateTime !== null
                        ? moment(info.startDateTime).format('HH:mm')
                        : null,
                endDate:
                    info.endDateTime !== null
                        ? moment(info.endDateTime)
                        : null,
                endDateTime:
                    info.endDateTime !== null ? moment(info.endDateTime).format('HH:mm') : null,
                location: info.location,
                attire: info.attire,
                notes: info.notes,
                activityTags: selectedTags

            });
            activityTags.set(selectedTags);
        } else {
            resetState();
        }
    }, [props.activityInfo]);

    useEffect(() => {
        handleDisableBtn();
    }, [state.get()]);

    const handleTagsChange = (newTags) => {
        let originalTags =
            props.activityInfo !== null &&
                props.activityInfo.activityTags !== null
                ? tags
                    .attach(Downgraded)
                    .get()
                    .filter((x) =>
                        [...props.activityInfo.activityTags]
                            .map((y) => y.tagID)
                            .includes(x.tagID)
                    )
                : [];
        let deletedTags = originalTags.filter(
            (x) => !newTags.map((y) => y.tagID).includes(x.tagID)
        );

        deletedTags = deletedTags.map((x) => {
            let obj = { ...x };
            obj['isDelete'] = true;
            return obj;
        });
        // newTags = newTags.map(x => {
        //     let obj = { ...x };
        //     obj['isDelete'] = false;
        //     return obj;
        // })
        state.activityTags.set(newTags);
        activityTags.set([...newTags, ...deletedTags]);
    };
    const handleStartDateChange = (newValue) => {
        state.startDate.set(dayjs(newValue))
    }
    const handleEndDateChange = (newValue) => {
        state.endDate.set(dayjs(newValue))
    }

    const renderDialogContent = () => {
        return (
            <>
                <Box
                    component="form"
                    sx={{
                        width: '100%',
                    }}>
                    <Box>
                        <TextField
                            required
                            fullWidth
                            type={'text'}
                            size="small"
                            value={state.get().eventName}
                            onChange={(e) => {
                                state.eventName.set(e.target.value),
                                    (e.target.value === "") ? setNameErr(true) : setNameErr(false)

                            }
                            }
                            id="outlined-required"
                            label="Activity Name"
                            aria-errormessage="Activity Name is required"
                            error={nameError}
                            onInput={(e) => {
                                e.target.value = e.target.value.slice(0, 200);
                            }}
                        />
                    </Box>
                    <Box sx={{ width: '100%', marginTop: 1 }}>
                        <Grid
                            container
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item lg={6} md={6} xs={12}
                                sx={{ width: '100%', marginTop: 1 }}>
                                <MUIDatePicker
                                    label="Start Date"
                                    value={state.startDate
                                        .attach(Downgraded)
                                        .get() ? state.startDate
                                            .attach(Downgraded)
                                            .get() : null}
                                    error={false}
                                    setValue={handleStartDateChange}
                                />
                                {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="Start Date"
                                        value={state.startDate
                                            .attach(Downgraded)
                                            .get() ? state.startDate
                                                .attach(Downgraded)
                                                .get() : null}
                                        // inputProps={{ readOnly: true }}
                                        // minDate={new Date()}
                                        onChange={(newValue) =>
                                            state.startDate.set(moment(newValue))
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                fullWidth
                                                required
                                                size="small"
                                                autoComplete="off"
                                                onKeyDown={(e) =>
                                                    e.preventDefault()
                                                }
                                            />
                                        )}
                                    />
                                </LocalizationProvider> */}
                            </Grid>
                            <Grid
                                item
                                lg={6}
                                md={6}
                                xs={12}
                                sx={{ width: '100%', marginTop: 1 }}>
                                {/* <LocalizationProvider
                                    dateAdapter={AdapterDateFns}>
                                    <DateTimePicker
                                        inputProps={{ readOnly: true }}
                                        label="Start Date & Time"
                                        value={state.startDateTime
                                            .attach(Downgraded)
                                            .get()}
                                        onChange={(newValue) => {
                                            state.startDateTime.set(newValue);
                                        }}
                                        cancelText
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                fullWidth
                                                size="small"
                                            />
                                        )}
                                    />
                                </LocalizationProvider> */}
                                <TimeSelector
                                    label='Start Time'
                                    value={state.startDateTime
                                        .attach(Downgraded)
                                        .get() === '00:00' ? null : state.startDateTime
                                            .attach(Downgraded)
                                            .get()}
                                    onChange={(newValue) => {
                                        state.startDateTime.set(newValue);
                                    }}
                                    errorMsg={''}
                                />
                            </Grid>


                        </Grid>

                    </Box>
                    <Box sx={{ width: '100%', marginTop: 1 }}>
                        <Grid
                            container
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item lg={6} md={6} xs={12}
                                sx={{ width: '100%', marginTop: 1 }}>
                                <MUIDatePicker
                                    label="End Date"
                                    value={state.endDate
                                        .attach(Downgraded)
                                        .get() ? state.endDate
                                            .attach(Downgraded)
                                            .get() : null}
                                    error={false}
                                    setValue={handleEndDateChange}
                                />
                                {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="End Date"
                                        value={state.endDate
                                            .attach(Downgraded)
                                            .get() ? state.endDate
                                                .attach(Downgraded)
                                                .get() : null}
                                        // minDate={new Date()}
                                        onChange={(newValue) =>
                                            state.endDate.set(moment(newValue))
                                            // handleHeaderDate(newValue)
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                fullWidth
                                                // required
                                                size="small"
                                                // helperText={headerDateErr}
                                                autoComplete="off"
                                                onKeyDown={(e) =>
                                                    e.preventDefault()
                                                }
                                            />
                                        )}
                                    />
                                </LocalizationProvider> */}
                            </Grid>
                            <Grid
                                item
                                lg={6}
                                md={6}
                                xs={12}
                                sx={{ width: '100%', marginTop: 1 }}>
                                {/* <LocalizationProvider
                                    dateAdapter={AdapterDateFns}>
                                    <DateTimePicker
                                        inputProps={{ readOnly: true }}
                                        label="End Date & Time"
                                        value={state.endDateTime
                                            .attach(Downgraded)
                                            .get()}
                                        onChange={(newValue) => {
                                            state.endDateTime.set(newValue);
                                        }}
                                        cancelText
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                fullWidth
                                                size="small"
                                            />
                                        )}
                                    />
                                </LocalizationProvider> */}
                                <TimeSelector
                                    label='End Time'
                                    value={state.endDateTime
                                        .attach(Downgraded)
                                        .get() === '00:00' ? null : state.endDateTime
                                            .attach(Downgraded)
                                            .get()}
                                    onChange={(newValue) => {
                                        state.endDateTime.set(newValue);
                                    }}
                                    errorMsg={''}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ width: '100%', marginTop: 1 }}>
                        <Grid
                            container
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid
                                item
                                lg={6}
                                md={6}
                                xs={12}
                                sx={{ width: '100%', marginTop: 1 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    type={'text'}
                                    id="outlined-required"
                                    value={state.get().location}
                                    onChange={(e) =>
                                        state.location.set(e.target.value)
                                    }
                                    label="Location"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.slice(
                                            0,
                                            260
                                        );
                                    }}
                                />
                            </Grid>
                            <Grid
                                item
                                lg={6}
                                md={6}
                                xs={12}
                                sx={{ width: '100%', marginTop: 1 }}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    type={'text'}
                                    id="outlined-required"
                                    value={state.get().attire}
                                    onChange={(e) =>
                                        state.attire.set(e.target.value)
                                    }
                                    label="Attire"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.slice(
                                            0,
                                            200
                                        );
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ width: '100%', marginTop: 1 }}>
                        <Grid
                            container
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid
                                item
                                lg={12}
                                md={12}
                                xs={12}
                                sx={{ width: '100%', marginTop: 1 }}>
                                {tags.get() ? (
                                    <Autocomplete
                                        multiple
                                        id="size-small-standard-multi"
                                        size="small"
                                        options={tags.attach(Downgraded).get()}
                                        getOptionLabel={(option) =>
                                            option.tagName
                                        }
                                        value={
                                            state.attach(Downgraded).get()
                                                .activityTags
                                        }
                                        onChange={(event, newValue) => {
                                            handleTagsChange(newValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Tags"
                                            />
                                        )}
                                    />
                                ) : null}
                            </Grid>
                        </Grid>
                    </Box>
                    <Box sx={{ width: '100%', marginTop: 1 }}>
                        <Grid
                            container
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid
                                item
                                lg={12}
                                md={12}
                                xs={12}
                                sx={{ width: '100%', marginTop: 1 }}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    multiline
                                    minRows={4}
                                    type={'text'}
                                    id="outlined-required"
                                    value={state.get().notes}
                                    onChange={(e) =>
                                        state.notes.set(e.target.value)
                                    }
                                    label="Notes"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.slice(
                                            0,
                                            1000
                                        );
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </>
        );
    };
    // console.log("state.get()",state.get());
    const renderDialogActions = () => {
        return (
            <ButtonContainer
                showLoading={true}
                loading={isLoading}
                handleClick={handleClick}
                handleCancel={props.handleClose}
                buttonText={props.activityInfo ? 'Update' : 'Create'}
                disableUpdateButton={props.activityInfo ? disableBtn : false}
            />
        );
    };
    const handleDisableBtn = () => {
        if (props.activityInfo) {
            const data = props.activityInfo;
            let prevActivityTags = [];
            data.activityTags.length > 0 &&
                data.activityTags.map((tag) => {
                    console.log(tag);
                    let obj = {
                        tagID: tag.tagID,
                        tagName: tag.tagName,
                        eventID: eventData.attach(Downgraded).get().eventID,
                        status: 1,
                        createdBy: tag.createdBy,
                    };
                    prevActivityTags.push(obj);
                });
            let prevData = {
                startDate: data.startDate,
                endDate: data.endDate,
                activityName: data.activityName,
                startDateTime: data.startDateTime,
                endDateTime: data.endDateTime,
                location: data.location,
                attire: data.attire,
                activityTags: prevActivityTags,
                notes: data.notes,
            };

            let currentData = {
                activityName: state.get().eventName,
                startDate:
                    state.get().startDate !== null
                        ? moment(state.get().startDate)
                        : null,
                endDate:
                    state.get().endDate !== null
                        ? moment(state.get().endDate).format('HH:mm')
                        : null,
                startDateTime:
                    state.get().startDateTime !== null
                        ? moment(state.get().startDateTime).format('HH:mm')
                        : null,
                endDateTime:
                    state.get().endDateTime !== null
                        ? moment(state.get().endDateTime).format('HH:mm')
                        : null,
                location: state.get().location,
                attire: state.get().attire,
                activityTags: activityTags.attach(Downgraded).get(),
                notes: state.get().notes,
            };
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true);
            } else {
                setDisableBtn(false);
            }
        }
    };
    const handleClick = () => {
        //let startDates = state.get().startDate !== null ? moment(state.get().startDate).format('YYYY-MM-DD') : null;
        //let endDates = state.get().endDate !== null ? moment(state.get().endDate).format('YYYY-MM-DD') : null;
        // var date1 = state.get().startDateTime !== null ? moment(state.get().startDateTime).format('HH:mm:ss') : null;
        // var date2 = state.get().endDateTime !== null ? moment(state.get().endDateTime).format('HH:mm:ss') : null;
        // Assuming you have imported the Day.js library as "dayjs"
        let startDates = state.get().startDate !== null ? dayjs(state.get().startDate).format('YYYY-MM-DD') : null;
        let endDates = state.get().endDate !== null ? dayjs(state.get().endDate).format('YYYY-MM-DD') : null;

        var startDateTimes = (state.get().startDate !== null || state.get().startDateTime !== null) ? moment(startDates + ' ' + (state.get().startDateTime !== null ? state.get().startDateTime : '00:00')).format('YYYY-MM-DD HH:mm:ss') : null;
        var endDateTimes = (state.get().endDate !== null || state.get().endDateTime !== null) ? moment(endDates + ' ' + (state.get().endDateTime !== null ? state.get().endDateTime : '00:00')).format('YYYY-MM-DD HH:mm:ss') : null;

        // console.log(state.get(), startDateTimes, endDateTimes, state.get().startDate === null && state.get().startDateTime !== null);

        if (state.get().eventName.trim() === '') {
            setNameErr(true);
        } else if (state.get().startDate === null) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please enter Start Date.',
            });
            return;
        }
        //  else if (state.get().startDate !== null && state.get().startDateTime === null) {
        //     props.setSnackBarProps({
        //         ...props.snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please enter Start Time.',
        //     });
        //     return;
        // } 
        // else if ((state.get().endDate === null && state.get().endDateTime !== null)) {
        //     props.setSnackBarProps({
        //         ...props.snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please enter End Date.',
        //     });
        //     return;
        // } else if (state.get().endDate !== null && state.get().endDateTime === null) {
        //     props.setSnackBarProps({
        //         ...props.snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please enter End Time.',
        //     });
        //     return;
        // } else if ((state.get().startDate !== null && state.get().startDateTime !== null) && (state.get().endDate === null && state.get().endDateTime === null)) {
        //     props.setSnackBarProps({
        //         ...props.snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please enter End Date and Time.',
        //     });
        //     return;
        // } 
        // else if ((state.get().endDate !== null && state.get().endDateTime !== null) && (state.get().startDate === null && state.get().startDateTime === null)) {
        //     props.setSnackBarProps({
        //         ...props.snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please enter Start Date and Time.',
        //     });
        //     return;
        // } 
        else {
            const sDate = new Date(state.get().startDate);
            sDate.setHours(0, 0, 0, 0);
            const eDate = new Date(state.get().endDate);
            eDate.setHours(0, 0, 0, 0);
            //  console.log(eDate,sDate,moment(eDate).format('YYYY-MM-DD') < moment(sDate).format('YYYY-MM-DD'));
            if ((state.get().startDate !== null && state.get().endDate !== null) && eDate < sDate) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message:
                        'End date should be greater than Start date.',
                });
            } else if ((state.get().endDateTime !== null && state.get().endDateTime !== '00:00' && state.get().endDateTime !== '') && startDateTimes !== null && endDateTimes !== null && endDateTimes < startDateTimes) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message:
                        'End date time should be greater than Start date time.',
                });
            } else {
                setIsLoading(true);
                let payLoad = {
                    activityID: props.activityInfo
                        ? props.activityInfo.activityID
                        : 0,
                    eventID: eventData.attach(Downgraded).get().eventID,
                    activityName: state.get().eventName,
                    startDateTime:
                        startDateTimes !== null
                            ? (moment(startDates + ' ' + (state.get().startDateTime !== null ? state.get().startDateTime : '00:00:00')).format('YYYY-MM-DDTHH:mm:ss'))
                            : null,
                    endDateTime:
                        endDateTimes !== null
                            ? (moment(endDates + ' ' + (state.get().endDateTime !== null ? state.get().endDateTime : '00:00:00')).format('YYYY-MM-DDTHH:mm:ss'))
                            : null,
                    location: state.get().location,
                    attire: state.get().attire.trim(),
                    notes: state.get().notes,
                    createdBy: userInfo.attach(Downgraded).get().userID,
                    modifiedBy: userInfo.attach(Downgraded).get().userID,
                    participants:
                        props.selectedUser && props.selectedUser > 0
                            ? [{ userID: props.selectedUser }]
                            : null,
                    activityTags: activityTags.attach(Downgraded).get(),
                    userType: ScheduleUserType[0],
                };

                return ApiHelper.post(APIURLConstants.POST_ACTIVITY_LIST, payLoad)
                    .then(() => {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: props.activityInfo
                                ? 'Activity updated successfully.'
                                : 'Activity created successfully.',
                        });
                        //let id = payLoad.participants !== null ? payLoad.participants[0].userID : 0;
                        props.handleClose();
                        props.getActivityList(0);
                        resetState();
                    })
                    .catch((err) => {
                        console.log(err);
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Error while adding activity.',
                        });
                    });
            }

        }
    };

    const resetState = () => {
        state.set({
            eventName: '',
            startDate: null,
            endDate: null,
            startDateTime: null,
            endDateTime: null,
            location: '',
            attire: '',
            notes: '',
            activityTags: [],
        });
    };
    return (
        <CustomDialog
            title={props.activityInfo?.activityID ? 'EDIT NEW ACTIVITY' : 'CREATE NEW ACTIVITY'}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};
export default AddAcctivity;
